/**
 * The frame every way in shares: sign in, two factor, and the first password. One layout
 * means the sequence reads as one thing rather than three pages that happen to follow each
 * other, and the brand panel keeps saying where you are while you work through it.
 */

/**
 * Name, accent, and the photograph that sits behind the panel. The file is looked up in
 * web/public/brand: a slot with no file just leaves that cell dark, so adding a business
 * photograph later is a matter of dropping in a jpg with the right name, nothing else.
 */
const BUSINESSES = [
  ['Ezel Spa', '#8a6014', 'spa.jpg'],
  ['Ezel Fashion', '#a21c6b', 'fashion.jpg'],
  ['Ezel Bites', '#c2410c', 'bites.jpg'],
  ['Ezel Apartment', '#0f766e', 'apartment.jpg'],
  ['Ezel Hotel', '#1d4ed8', 'hotel.jpg'],
  ['Ezel Laundry', '#FFC400', 'laundry.jpg']
];

export function Entrance({ children }) {
  return (
    <div className="entrance">
      <aside className="entrance-brand">
        <div className="entrance-mosaic" aria-hidden="true">
          {BUSINESSES.map(([name, , file]) => (
            <i key={name} style={{ backgroundImage: `url(/brand/${file})` }} />
          ))}
        </div>
        <div className="entrance-scrim" aria-hidden="true" />
        <div className="entrance-mark">
          <span className="bar" />
          <span>
            <span className="word" style={{ display: 'block' }}>EPMS</span>
            <span className="sub">Ezel Place Management Software</span>
          </span>
        </div>

        <div className="entrance-lead">One system. <em>Six businesses.</em></div>

        <div className="entrance-note">
          Every sale, booking and shift at Ezel Place, Oyarifa, on one till and one set of
          books. Sign in with the account you were given, not a shared one: receipts print
          the name of whoever rang them up.
        </div>

        <ul className="entrance-list">
          {BUSINESSES.map(([name, colour]) => (
            <li key={name}>
              <span className="dot" style={{ background: colour }} />
              {name}
            </li>
          ))}
        </ul>

        <div className="entrance-foot">Oyarifa, Accra &middot; Every sign in is recorded</div>
      </aside>

      <main className="entrance-form">
        <div className="entrance-card">{children}</div>
        <div className="entrance-colophon">
          <span>EPMS</span>
          <span className="rule" />
          <span>Built for Ezel Place, not bought off a shelf</span>
        </div>
      </main>
    </div>
  );
}

/** Kept for the loading flash and anything else that just needs the middle of the screen. */
export function Centered({ children }) {
  return (
    <div style={{ minHeight: '100%', display: 'grid', placeItems: 'center', padding: 'var(--space-xl)' }}>
      {children}
    </div>
  );
}
